import "./index.css";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { UsersRepository } from "@/api/users/repository";
import { UsersService } from "@/api/users/service";
import { Button, Checkbox, Modal } from "@/ui-kit";
import { serverErrorHandler } from "@/utils/serverErrorHandler";

type IProps = {
  onSuccess: () => void;
};

export const PrivacyConsentModal = ({ onSuccess }: IProps) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const usersRepository = useMemo(() => {
    return new UsersRepository(new UsersService());
  }, []);

  const handleSubmit = useCallback(() => {
    setLoading(true);
    usersRepository
      .postPrivacyConsent()
      .then(() => {
        onSuccess();
      })
      .catch(
        serverErrorHandler(() => {
          setChecked(false);
        }),
      );
  }, [usersRepository, onSuccess]);

  return (
    <Modal
      open={true}
      onOpenChange={() => {}}
      closeOnOutsidePress={false}
      className="privacy-consent__modal"
    >
      <Modal.Header showClose={false} title={t("label.privacyConsent.title")} />
      <Modal.Body>
        <Checkbox
          checked={checked}
          onChange={setChecked}
          label={t("label.privacyConsent.consentText")}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!checked}
          loading={loading}
          onClick={handleSubmit}
          content={t("label.privacyConsent.agreeAndContinue")}
        />
      </Modal.Footer>
    </Modal>
  );
};
